import React, { useMemo } from 'react';
import * as Styles from './AiAlertsCta.styles';
import { IconButton, Skeleton } from 'gatorcomponents';
import { useAiChat } from '@/hooks/AiChat';
import { ATIVACAO_ENABLE_AI_ALERTS } from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

const AiAlertsCta = ({
  label,
  cta,
  atCardOptions,
  loading,
  alertsTypes,
  alerts,
  isInsideChat = false,
}) => {
  const severity = useMemo(() => {
    if (!alertsTypes) {
      return 'warning';
    }

    const hasCritical = alerts && alerts.some((alert) => {
      if (!alert || !alert.type || !alert.type.slug) {
        return false;
      }
      return alertsTypes[alert.type.slug].severity === 'critical';
    });

    return hasCritical ? 'critical' : 'warning';
  }, [alertsTypes, alerts]);

  const withAiAlerts = useFeatureIsOn(ATIVACAO_ENABLE_AI_ALERTS);
  const { handleOpenAlerts } = useAiChat();

  const handleClick = () => {
    handleOpenAlerts && handleOpenAlerts();
  };

  const hasNoAlerts = alerts && alerts.length === 0;

  const shouldRenderNull = !withAiAlerts || hasNoAlerts;

  if (shouldRenderNull) {
    return null;
  }

  if (loading) {
    return (
      <Skeleton variant="rectangle" width="386px" height="40px" />
    );
  }

  return (
    <Styles.AiAlertsCtaWrapper onClick={handleClick} $isInsideChat={isInsideChat}>
      <Styles.SeverityDot $severity={severity} data-testid="severityDot" />
      {label && (
        <Styles.Label data-testid="label">
          {label}
        </Styles.Label>
      )}
      <Styles.ResolveCta $dark={atCardOptions} data-testid="cta">
        {cta}

        {!atCardOptions && (
          <IconButton icon="IconChevron" />
        )}
      </Styles.ResolveCta>
    </Styles.AiAlertsCtaWrapper>
  );
};

export default AiAlertsCta;
